var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9881 15.8831L11.7709 10.6659C12.5805 9.61925 13.0184 8.33956 13.0184 6.99358C13.0184 5.38242 12.3896 3.87171 11.2526 2.73264C10.1155 1.59358 8.60078 0.966797 6.99163 0.966797C5.38248 0.966797 3.86775 1.59559 2.73069 2.73264C1.59163 3.8697 0.964844 5.38242 0.964844 6.99358C0.964844 8.60273 1.59364 10.1175 2.73069 11.2545C3.86775 12.3936 5.38047 13.0204 6.99163 13.0204C8.33761 13.0204 9.61529 12.5824 10.6619 11.7748L15.8791 16.99C15.8944 17.0053 15.9126 17.0175 15.9326 17.0257C15.9526 17.034 15.974 17.0383 15.9956 17.0383C16.0173 17.0383 16.0387 17.034 16.0587 17.0257C16.0787 17.0175 16.0969 17.0053 16.1122 16.99L16.9881 16.1161C17.0034 16.1008 17.0155 16.0827 17.0238 16.0627C17.0321 16.0427 17.0363 16.0212 17.0363 15.9996C17.0363 15.978 17.0321 15.9565 17.0238 15.9365C17.0155 15.9166 17.0034 15.8984 16.9881 15.8831ZM10.1738 10.1757C9.32199 11.0255 8.19297 11.4936 6.99163 11.4936C5.79029 11.4936 4.66127 11.0255 3.80949 10.1757C2.95971 9.32394 2.49163 8.19492 2.49163 6.99358C2.49163 5.79224 2.95971 4.66122 3.80949 3.81144C4.66127 2.96166 5.79029 2.49358 6.99163 2.49358C8.19297 2.49358 9.324 2.95965 10.1738 3.81144C11.0235 4.66323 11.4916 5.79224 11.4916 6.99358C11.4916 8.19492 11.0235 9.32595 10.1738 10.1757Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.b4b34bcee5671c4b7f1154718fbe5767.svg";
export { ForwardRef as ReactComponent };